import { render, staticRenderFns } from "./AddTaskLog.vue?vue&type=template&id=59f1a04f&scoped=true&"
import script from "./AddTaskLog.vue?vue&type=script&lang=js&"
export * from "./AddTaskLog.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskLog.vue?vue&type=style&index=0&id=59f1a04f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f1a04f",
  null
  
)

export default component.exports